type Config = {
    onMatch?: (initial: boolean) => void;
    onNotMatched?: (initial: boolean) => void;
    onChange?: (e: MediaQueryListEvent) => void;
};

const mdRem = 48;

export const sm = "(width >= 40rem)";
export const md = `(width >= ${mdRem}rem)`;
export const lessThanMd = `(width < ${mdRem}rem)`;
export const lg = "(width >= 64rem)";
export const xl = "(width >= 80rem)";

export const mediaQuery = (query: string, config: Config = {}) => {
    const mq = window.matchMedia(query);

    mq.addEventListener("change", (e) => {
        if (config.onChange) {
            config.onChange(e);
        }

        if (e.matches) {
            config.onMatch?.(false);
        } else {
            config.onNotMatched?.(false);
        }
    });

    if (mq.matches) {
        config.onMatch?.(true);
    } else {
        config.onNotMatched?.(true);
    }

    return mq;
};

export const onLargeScreens = (config: Config = {}) => {
    return mediaQuery(lg, config);
};

export const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
).matches;
